<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>ภาษา</b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'LanguageAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
      </ul>
    </nav>
    <div v-for="language in data.languages" class="card col-md-12" :key="language.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4 text-center">
            <div data-spy="scroll" data-offset="0">
              <div class="col-sm-12 text-center" style="overflow: hidden">
                <h4>
                  <span v-bind:class="'flag-icon flag-icon-us'" v-if="language.short_name=='en'"></span>
                  <span v-bind:class="'flag-icon flag-icon-'+language.short_name" v-if="language.short_name!='en'"></span>
                  &nbsp;<span v-html="language.name"></span>
                </h4>
                (<span v-html="language.short_name"></span>)
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="offset-lg-2 col-lg-4 col-sm-4">
                <b-btn @click="$router.push({ name: 'LanguageEdit',params: { id: language.id }})" class="mt-3"
                  variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
              </div>
              <div class="col-lg-4 col-sm-4">
                <b-btn @click="alertDeleteLanguage(language.id,language.name)" class="mt-3" variant="outline-primary"
                  block :disabled="data.count === 1"><i class="fas fa-trash-alt"></i> ลบ</b-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="language.alert.title" ref="alert" hide-footer v-model="language.alert.active" @ok="language.alert.active = false">
      <div v-if="language.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="language.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="language.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="language.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="language.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="language.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="language.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="language.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        language: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        lang: 'th',
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          languages: {},
          count: 0
        }
      }
    },
    mounted() {
      this.startLoad(1)
      this.getLanguages()
    },
    methods: {
      getLanguages() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          this.data.languages = response.body.json
          this.data.count = response.body.json.length
        }, response => {
          this.failLoad()
        })
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeleteLanguage(id, languageName) {
        this.language.id = id
        this.language.name = languageName
        this.language.alert.title = 'การลบภาษา'
        this.language.alert.detail = 'คุณต้องการลบภาษา "<b>' + languageName + '</b>" ใช่หรือไม่?'
        this.language.alert.open.active = true
        this.language.alert.close.active = true
        this.language.alert.open.name = 'ยืนยันการลบ'
        this.language.alert.close.name = 'ยกเลิกการลบ'
        this.language.alert.active = true
      },
      submitDelete() {
        this.language.alert.load = true
        this.deleteLanguageByShortName()
      },
      deleteLanguageByShortName() {
        if (this.language.id && this.language.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/language/' + this.language.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.language.alert.load = false
            this.getLanguages()
            this.language.alert.detail = 'ทำการลบภาษาหมายเลข: ' + response.body.json.language.id + ' เรียบร้อย'
            this.language.alert.open.active = false
            this.language.alert.close.name = 'ปิด'
            this.language.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.language.alert.detail = 'ไม่สามารถทำการลบภาษาได้!'
            this.language.alert.open.active = false
            this.language.alert.close.name = 'ปิด'
            this.language.alert.active = true
          })
        }
      }
    }
  }

</script>
